import React, { useState, useEffect } from 'react'
import { Button, Carousel, Tooltip, message, Input, Select, Pagination, ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import left from '../../img/left.png'
import right from '../../img/right.png'
import header from '../../img/header.png'
import banner2 from '../../img/banner2.jpg'
import banner6 from '../../img/banner6.png'
import renCai from '../../img//renCai.png'
import white from '../../img/white.png'
import xinWen1 from '../../img/xinWen1.jpg'
import xinWen2 from '../../img/2.jpg'
import xinWen4 from '../../img/4.jpg'
import xinWen5 from '../../img/5.jpg'
import xinWen6 from '../../img/6.jpg'
import xinWen7 from '../../img/xinWen7.png'
import xinWen8 from '../../img/xinWen8.jpg'
import xinWen9 from '../../img/xinWen9.jpg'
import xinWen10 from '../../img/xinWen10.jpg'
import xinWen11 from '../../img/xinWen11.jpg'
import huoDong from '../../img/huoDong.jpg'
import phone from '../../img/phone.svg'
import email from '../../img/email.svg'
import work from '../../img/work.svg'
import shenBao from '../../img/shenBao.png'
import fanHui from '../../img/fanHui.png'
import dianZan from '../../img/dianZan.svg'
import shang from '../../img/shang.svg'
import xia from '../../img/xia.svg'
import axios from 'axios'
import { createFromIconfontCN } from '@ant-design/icons';
import { recommendCourseList, courseZan } from "../../http/modules/login";
import './index.scss'
const { Search } = Input;
const { Option } = Select;

export default function Index() {
    // icon
    const IconFont = createFromIconfontCN({ scriptUrl: '//at.alicdn.com/t/c/font_4211936_i3q5g499wn.js' });

    const resizeListener = () => {
        // 定义设计图的尺寸 3840
        let designSize = 1920;
        // 获取 html 元素
        let html = document.documentElement;
        // 定义窗口的宽度
        let clientW = html.clientWidth;
        // html 的fontsize 大小
        let htmlRem = (clientW * 16) / designSize;
        html.style.fontSize = htmlRem + 'px';
    }

    useEffect(() => {
        window.addEventListener('resize', resizeListener);
        resizeListener();
    }, [])

    const [middle, setMiddle] = useState(true)
    const [headerActive, setHeaderActive] = useState('首页')
    // 课程列表数据
    const [curriculum, setCurriculum] = useState()
    // 当前页数
    const [pageNo, setPageNo] = useState(1)
    // 总页数
    const [totalPage, setTotalPage] = useState()
    // 搜索的内容
    const [searchN, setSearchN] = useState('')
    // 筛选的内容
    const [category, setCategory] = useState('')
    // 总条数
    const [total, setTotal] = useState()

    const now = new Date();
    // 当前年份
    const [currentYear, setcurrentYear] = useState(now.getFullYear());
    // 搜多的年份
    const [searchYear, setSearchYear] = useState(now.getFullYear().toString());

    const headerTitle = [
        {
            text: '首页',
            url: ''
        },
        {
            text: '活动介绍',
            url: 'main2'
        },
        {
            text: '优课展示',
            url: 'main1'
        },
        {
            text: '名师展示',
            url: ''
        },
        {
            text: '新闻动态',
            url: 'main3'
        },
    ]

    const scrollToAnchor = (anchorName) => {
        if (anchorName) {// 找到锚点
            let anchorElement = document.getElementById(anchorName);
            // 如果对应id的锚点存在，就跳转到锚点
            if (anchorElement) { anchorElement.scrollIntoView({ block: 'start', behavior: 'smooth' }); }
        }
    }

    const contentStyle = {
        height: '30.4375rem',
        color: 'red',
        lineHeight: '10rem',
        textAlign: 'center',
        background: '#364d79',
    };

    // 课程列表
    const onCurriculum = async (pageNo, searchTxt = '', category = '', year = searchYear.toString()) => {

        setSearchN(searchTxt)
        setCategory(category)

        try {
            axios({
                method: "post",
                url: 'https://qiyeweike.com/api/v1/home/testRecommendCourseList',
                data: {
                    "pageNo": pageNo,
                    "pageSize": 12,
                    "searchTxt": searchTxt,
                    "category": category,
                    "year": year
                }
            }).then((res) => {
                if (res.data.code == 0) {
                    setCurriculum(res.data.data.list)
                    setPageNo(res.data.data.pageNo)
                    setTotalPage(res.data.data.totalPage)
                    setTotal(res.data.data.total)
                } else {
                    message.error(res.msg);
                }
            })
        } catch (error) {
            console.log(error);
        }
    };

    // 点赞
    const onCourseZan = async (courseUUID) => {
        try {
            const res = await courseZan({
                "courseUUID": courseUUID
            }, {
                Headers: {
                    'token': 'eyJhbGciOiJIUzI1NiIsImN0eSI6IkpXVCIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJxaXlld2Vpa2UuZ2F0ZXdheSIsInN1YiI6IkFjY2Vzc1Rva2VuIiwiYXVkIjoiaHR0cHM6Ly9xaXlld2Vpa2UuY29tIiwiZXhwIjoyMDE1Mzc4MjM2LCJuYmYiOjE3MDAwMTc5MzYsImlhdCI6MTcwMDAxODIzNiwianRpIjoiOWY5Y2RhNjgtODYxOC00ZTg2LWEwMDMtOTk5MTRlNmMyNWQzIiwidXNlcl91dWlkIjoiMTk5OTk5OTk5OTkifQ.pv_r-pEuLtJBjC5WuT0sbdy4ifH30LgFkNPtcPA6pzc'
                }
            }
            );
            if (res.code == 0) {
                onCurriculum(pageNo, searchN)
            } else {
                message.error(res.msg);
            }
        } catch (error) {
            console.log(error);
        }
    };

    // 搜索
    const onSearch = (value) => onCurriculum(1, value, category, searchYear);

    useEffect(() => {
        onCurriculum(1)
    }, [])

    const setIsPlaying = (e) => {
        let kv = { "视频名称": e.title, "uuid": e.courseUUID }
        window.TDAPP.onEvent('视频播放', '', kv);
    }

    // 分页跳转
    const onPagination = pageNumber => {
        onCurriculum(pageNumber, searchN, category, searchYear)
    };

    const showTotal = total => `共 ${total} 条`;

    return (
        <div className='shouYeCopys'>
            <header id='header'>
                <div>
                    <img src={header} alt="" />
                </div>
                <div>
                    {headerTitle.map((item, index) => {
                        return <a key={index} className={headerActive == item.text ? 'active' : ''} href='javascript:void(0)' onClick={(e) => { setHeaderActive(e.target.innerHTML); scrollToAnchor(item.url) }}>
                            {item.text}
                        </a>
                    })}
                </div>
                <div>
                    <Tooltip onClick={() => { window.open('/login?a=signIn', '_blank') }} placement="topLeft" /* title={'10月7日开放申报'} */>
                        <Button >注册</Button>
                    </Tooltip>
                    <Tooltip onClick={() => { window.open('/login?a=register', '_blank') }} placement="topLeft" /* title={'10月7日开放申报'} */>
                        <Button>登录</Button>
                    </Tooltip>
                </div>
            </header>
            <Carousel autoplay speed={1000} autoplaySpeed={2000} effect="fade" dotPosition={'bottom'}>
                <div>
                    <h3 style={contentStyle}>
                        <a target="_blank" >
                            <img src={banner6} alt="" /></a>
                    </h3>
                </div>
                <div>
                    <h3 style={contentStyle}>
                        <a target="_blank" href="https://wap.miit.gov.cn/ztzl/rdzt/xxgzbdgrdfyyqfkgz/tzgg/art/2020/art_741d172bcc2b47a39f729f84358da269.html">
                            <img src={banner2} alt="" />
                        </a>
                    </h3>
                </div>
            </Carousel>
            <h1 id='main1'>
                <div>
                    <img src={left} alt="" /> 企业微课 <img src={right} alt="" />
                </div>
            </h1>
            <main>
                <div className='mainHeader'>
                    <div className='mainHeaderDiv'>
                        <Search placeholder="地区/授课人/课程名称" onSearch={onSearch} enterButton />
                        <Select
                            placeholder="请选择"
                            value={category}
                            onChange={(value) => { onCurriculum(1, searchN, value, searchYear); setCategory(value) }}
                            showArrow={false}
                            suffixIcon={null}
                            className="custom-select"
                        >
                            <Option key={'全部'} value={''}>全部</Option>
                            <Option key={'法律法规类'} value={'法律法规类'}>法律法规类</Option>
                            <Option key={'政策解读类'} value={'政策解读类'}>政策解读类</Option>
                            <Option key={'经营管理类'} value={'经营管理类'}>经营管理类</Option>
                            <Option key={'创新发展类'} value={'创新发展类'}>创新发展类</Option>
                            <Option key={'权益保护类'} value={'权益保护类'}>权益保护类</Option>
                            <Option key={'创业指导类'} value={'创业指导类'}>创业指导类</Option>
                            <Option key={'企业出海类'} value={'企业出海类'}>企业出海类</Option>
                            <Option key={'其他类'} value={'其他类'}>其他类</Option>
                        </Select>
                        <Select
                            className="custom-select"
                            suffixIcon={null}
                            showArrow={false}
                            defaultValue={'2026'}
                            onChange={(value) => { onCurriculum(1, searchN, category, value); setSearchYear(value) }}
                            options={[
                                {
                                    value: '2026',
                                    label: '2026',
                                },
                                {
                                    value: '2025',
                                    label: '2025',
                                },
                                {
                                    value: '2024',
                                    label: '2024',
                                },
                                {
                                    value: '2023',
                                    label: '2023',
                                }
                            ]}
                        />
                    </div>
                </div>
                {curriculum?.length ? curriculum?.map((item, index) => {
                    return <div key={index} className='div2'>
                        <div className='divHeader'>
                            {/* <video onPlay={() => setIsPlaying(item)} src={item.mainCourseUrl} controls muted preload='metadata'></video> */}
                            <video onPlay={() => setIsPlaying(item)} controls="controls" muted preload='metadata' controlslist="nodownload">
                                <source src={item.mainCourseUrl} type="video/mp4" />
                            </video>
                        </div>
                        <div className='divFooter'>
                            <p title={item.title}> {item.title} </p>
                        </div>
                    </div>
                }) : <div className='zanWu'>
                    {/* 敬请期待，请进入{currentYear}年 <button className='zanWuButton' onClick={() => { window.open('/login', '_blank') }}>申报入口</button> */}
                    暂无数据
                </div>}

                <div className='pagination'>
                    <ConfigProvider locale={zhCN}><Pagination onChange={onPagination} current={pageNo} showTotal={showTotal} pageSize={12} showSizeChanger={false} showQuickJumper defaultCurrent={1} total={total} /></ConfigProvider>
                </div>
            </main>
            <h1 id='main2'>
                <div>
                    <img src={left} alt="" /> 活动介绍 <img src={right} alt="" />
                </div>
            </h1>
            <div className='main2'>
                <div>
                    <div><img src={huoDong} alt="" /></div>
                    <div>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 中小企业人才培训“名师优课”征集遴选工作主要征集面向中小企业生产经营管理的培训课程、专题讲座等视频内容，
                        活动旨在贯彻落实党中央、国务院关于促进中小企业健康发展的决策部署，进一步加强中小企业人才培养公共服务，切实提升中小企业经营管理人员综合素养，
                        促进中小企业高质量发展。
                    </div>
                </div>
                {/* <div className='Timeline'>
                    <div>
                        <p style={{ color: '#2284F7' }}>线上申报</p>
                        <p><span /></p>
                        <p style={{ color: '#2284F7' }}>2023年10月7日</p>
                    </div>
                    <div>
                        <p>申报结束</p>
                        <p> <span /> </p>
                        <p>2023年10月25日</p>
                    </div>
                    <div>
                        <p>地方审核推荐</p>
                        <p><span /></p>
                        <p>2023年11月10日前</p>
                    </div>
                    <div>
                        <p>遴选发布</p>
                        <p><span /></p>
                        <p>&nbsp;</p>
                    </div>
                </div> */}
                {/* <div className='xiaZai' id='main3' style={{marginTop:'30px'}}>
                    下载资料：
                    <a href="https://obs-bj3.cucloud.cn/qiyeweike/www/%E5%9C%B0%E6%96%B9%E5%88%9D%E9%80%89%E6%A0%87%E5%87%86.doc">1.地方初选标准</a>
                    <a href="https://obs-bj3.cucloud.cn/qiyeweike/www/%E8%AF%BE%E7%A8%8B%E7%94%B3%E6%8A%A5%E8%A1%A8.doc">2.课程申报表</a>
                    <a href="https://obs-bj3.cucloud.cn/qiyeweike/www/%E6%8E%A8%E8%8D%90%E8%AF%BE%E7%A8%8B%E6%B1%87%E6%80%BB%E8%A1%A8.doc">3.推荐课程汇总表</a>
                </div> */}
            </div>
            <h1>
                <div>
                    <img src={left} alt="" /> 新闻动态 <img src={right} alt="" />
                </div>
            </h1>
            <div className='main3' id='main3'>

                <div className='xinWen'>
                    <img src={xinWen11} className='xinWenImg' />
                    <div>
                        <p><a target="_blank" href="https://wap.miit.gov.cn/zwgk/zcwj/wjfb/tz/art/2024/art_3946a0e1162d4dec944b6e61f9f6ef36.html"><IconFont type={'icon-hongqi'} />关于开展2024年中小企业人才培训“名师优课”征集遴选工作的通知</a></p>
                        <p><span>日期：2024-07-02　</span>    <span>来源：工业和信息化部办公厅</span> </p>
                    </div>
                </div>

                <div className='xinWen'>
                    <img src={xinWen10} />
                    <div>
                        <p><a target="_blank" href="https://www.miit.gov.cn/zwgk/zcwj/wjfb/tz/art/2024/art_3bdc9c3b02b24f6b91ca3b8f2840c634.html">工业和信息化部办公厅关于发布首批中小企业人才培训“名师优课”优质课程的通知</a></p>
                        <p><span>日期：2024-01-22　</span>    <span>来源：工业和信息化部办公厅</span> </p>
                    </div>
                </div>

                <div className='xinWen'>
                    <img src={xinWen9} />
                    <div>
                        <p><a target="_blank" href="http://www.cb.com.cn/index/show/gd/cv/cv1362127001490">工业和信息化部名师优课遴选进行时，200余名专家讲师角逐TOP50</a></p>
                        <p><span>日期：2023-12-22　</span>    <span>来源：中国经营网</span> </p>
                    </div>
                </div>

                <div className='xinWen'>
                    <img src={xinWen7} />
                    <div>
                        <p><a target="_blank" href="https://baijiahao.baidu.com/s?id=1785611972154091273">“名师优课”公众评价火热进行！再为中小企业送政策、送技术、送管理</a></p>
                        <p><span>日期：2023-12-18　</span>    <span>来源：中国经济时报</span> </p>
                    </div>
                </div>

                <div className='xinWen'>
                    <img src={xinWen8} />
                    <div>
                        <p><a target="_blank" href="https://mp.weixin.qq.com/s/lavVo7QVeCXnFP3hHo5ang">“名师优课”为中小企业送政策、送技术、送管理</a></p>
                        <p><span>日期：2023-12-16　</span>    <span>来源：工业和信息化部人才交流中心</span> </p>
                    </div>
                </div>

                {middle ? <div className='button'><Button onClick={() => setMiddle(false)} type="primary">查看更多</Button></div> : <div className='divS' >

                    <div className='xinWen'>
                        <img src={xinWen1} />
                        <div>
                            <p><a target="_blank" href="https://www.miit.gov.cn/jgsj/qyj/wjfb/art/2023/art_e826f31bd69d4b5ea3ade5ef5973ea47.html">关于开展中小企业人才培训“名师优课”征集遴选工作的通知</a></p>
                            <p><span>日期：2023-09-27 　</span>    <span>来源：工业和信息化部</span> </p>
                        </div>
                    </div>

                    <div className='xinWen'>
                        <img src={xinWen4} />
                        <div>
                            <p><a target="_blank" href="https://ythxxfb.miit.gov.cn/ythzxfwpt/hlwmh/tzgg/sbfw/qyshzr/art/2023/art_2b78d149fb4c4a12b4b884f913eabcb8.html">工业和信息化部办公厅关于开展数字化赋能、科技成果赋智、质量标准品牌赋值中小企业全国行活动的通知</a></p>
                            <p><span>日期：2023-06-27 　</span>    <span>来源：工业和信息化部</span> </p>
                        </div>
                    </div>

                    <div className='xinWen'>
                        <img src={xinWen5} />
                        <div>
                            <p><a target="_blank" href="https://www.miit.gov.cn/xwdt/gxdt/ldhd/art/2023/art_06877ccc08bb41c999ade1cf20e75f93.html">科技成果赋智、质量标准品牌赋值中小企业专项行动政策吹风会举行</a></p>
                            <p><span>日期：2023-05-19  　</span>    <span>来源：科技司、中小企业局、办公厅、工信微报</span> </p>
                        </div>
                    </div>

                    <div className='xinWen'>
                        <img src={xinWen6} />
                        <div>
                            <p><a target="_blank" href="https://www.miit.gov.cn/jgsj/rjj/wjfb/art/2022/art_9a02c9fb711649caacee9f05b92c92c0.html">工业和信息化部关于加强和改进工业和信息化人才队伍建设的实施意见</a></p>
                            <p><span>日期：2022-10-18　 </span>    <span>来源：工业和信息化部</span> </p>
                        </div>
                    </div>

                    <div className='xinWen'>
                        <img src={xinWen2} />
                        <div>
                            <p><a target="_blank" href="https://mp.weixin.qq.com/s/0JsAS-YnU4Opt60dj4Tmig">工信部组织开展“企业微课”线上培训 为中小企业免费送政策、送技术、送管理</a></p>
                            <p><span>日期：2020-02-11　</span>    <span>来源：工信微报</span> </p>
                        </div>
                    </div>
                </div>}
            </div>
            <footer>
                <div>
                    <img src={header} alt="" />
                </div>
                <div>
                    {/* <p> <img src={phone} alt="" /> 客服热线/手机：18851108692</p> */}
                    <p> <img src={phone} alt="" /> 客服热线/座机：010-68207843</p>
                    <p> <img src={email} alt="" /> 客服邮箱：jiayue@miitec.cn</p>
                    <p> <img src={work} alt="" /> 服务时间：9:00-17:00</p>
                </div>
                <div>
                    <p>Copyright © {currentYear}</p>
                    <p>企业微课qiyeweike.miitec.cn版权所有</p>
                    <p><a target="_blank" href="https://beian.miit.gov.cn">京ICP备07500136号-4</a></p>
                </div>
                <div>
                    <p> <img src={renCai} alt="" />工业和信息化部人才交流中心</p>
                    {/*<p> <img src={white} alt="" />工信领军（北京）科技有限公司</p>*/}
                </div>
            </footer>
            <div className='fanHui'>
                <div>
                    <p onClick={() => { window.open('/login', '_blank') }}>
                        <img src={shenBao} alt="" />
                        申报入口
                    </p>

                    <p onClick={() => scrollToAnchor('header')}>
                        <img src={fanHui} alt="" />
                        返回顶部
                    </p>
                </div>
            </div>
        </div>
    )
}
